import React, { useState, useCallback, useRef } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IconCaretDown } from '@loadsmart/icons'

import Logo from 'components/Logo'
import { logout } from 'services/auth'
import { carrierEmailSelector } from 'features/carrierProposal/selectors'
import { userSelector } from 'features/user/selectors'
import { carrierLogoSelector } from 'features/carrierProposal/selectors'
import { pageWrapperStyle } from 'styles/page'
import { useOnClickOutside } from 'hooks/useOnClickOutside'

const HeaderStyled = styled.header`
  ${pageWrapperStyle}
  align-items: center;
  background: ${({ theme }) => theme.colors.backgroundSecondary};
  display: flex;
  height: 50px;
  justify-content: space-between;
`
const UnstyledButton = styled.button<{ isCarrier?: boolean }>`
  background: none;
  border: none;
  ${({ isCarrier }) => !isCarrier && `cursor: pointer;`}

  :focus {
    box-shadow: none;
    outline: none;
  }
`
const MenuButton = styled(UnstyledButton)`
  color: ${({ theme }) => theme.colors.background};
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  margin: 8px 0px;
  padding: 0 10px;
  text-align: left;
  text-transform: uppercase;
  width: 100%;
`
const Menu = styled.div`
  background: ${({ theme }) => theme.colors.backgroundSecondary};
  padding: 5px 0;
  position: absolute;
  right: 0;
  top: 100%;
  width: max-content;
`
const MenuWrapper = styled.div`
  position: relative;
`
const LoginLink = styled(Link)`
  color: ${({ theme }) => theme.colors.background};
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  margin: 8px 0px;
  text-align: left;
  text-decoration: none;
  text-transform: uppercase;
`

export default function Header() {
  const ref = useRef(null)
  const [isOpen, setOpen] = useState(false)
  const toggleOpen = useCallback(() => {
    setOpen(!isOpen)
  }, [isOpen])
  const closeMenu = useCallback(() => setOpen(false), [])
  const carrierEmail = useSelector(carrierEmailSelector)
  const user = useSelector(userSelector)
  const carrierLogo = useSelector(carrierLogoSelector)
  const userIdentifier = carrierEmail || user.name || user.email
  const isCarrier = window.location.pathname
    .toLowerCase()
    .startsWith('/carrier')

  useOnClickOutside(ref, closeMenu)

  return (
    <HeaderStyled>
      <Logo logoURL={user.logo || carrierLogo || ''} />
      {userIdentifier ? (
        <MenuWrapper ref={ref}>
          <MenuButton onClick={toggleOpen} isCarrier={isCarrier}>
            {userIdentifier}&nbsp;
            {!isCarrier && <IconCaretDown width={10} />}
          </MenuButton>
          {isOpen && !isCarrier && (
            <Menu>
              <MenuButton onClick={logout}>Logout</MenuButton>
            </Menu>
          )}
        </MenuWrapper>
      ) : (
        !isCarrier && <LoginLink to="/login">Login</LoginLink>
      )}
    </HeaderStyled>
  )
}
